import * as React from 'react';
import './index.scss';
import { fetch, RankItem, RichRankRsp } from '@/fetch.ts';
import RankHeader from '@hooks/public/rankHeader.tsx';
import Page from '@hooks/public/page.tsx';
import AnchorItem from '@hooks/public/anchorItem.tsx';
import NoneData from '@hooks/public/none.tsx';
interface Props {
  iAreaId: number,
}
const { useState, useEffect } = React;

const Rich: React.FC<Props> = props => {

  const [list, List] = useState<RankItem[]>([]);
  const [showList, ShowList] = useState<RankItem[]>([]);
  const [pageShow, PageShow] = useState<boolean>(true);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 5, (index + 1) * 5 >= list.length ? list.length : (index + 1) * 5));
  }
  useEffect(() => {
    PageShow(false);
    /* 获取分区榜单 */
    fetch.StarGetRichRank(
      {
        iAreaId: props.iAreaId,
      },
    )
      .then((rsp: RichRankRsp) => {
        // console.log('神豪榜 大区：', props.iAreaId, JSON.stringify(rsp));
        PageShow(true);
        List(rsp.tPanel.vRankList.value.slice(0, 50));
        ShowList(rsp.tPanel.vRankList.value.length > 5 ? rsp.tPanel.vRankList.value.slice(0, 5) : rsp.tPanel.vRankList.value);
      })
  }, [props.iAreaId])
  return (
    <div className='rich' id='rich'>
      <i className={`rank-rich-${props.iAreaId}`} />
      <RankHeader
        width={855}
        color='#ffefbb'
        prev='排名'
        mid='神豪昵称'
        next={'贡献值'}
      />
      <div className='rich-List'>
        {
          showList.length === 0 ?
            <NoneData text={'暂无数据'} />
            :
            showList.map((item: RankItem) => {
              return (
                <AnchorItem
                  key={item.tJump.lPid}
                  width={860}
                  {...item}
                  rich={true}
                />
              )
            })
        }
      </div>
      {
        pageShow &&
        <Page
          pageLen={list.length % 5 === 0 ? list.length / 5 : Math.floor(list.length / 5) + 1}
          setPageIndex={pageChange}
        />
      }
    </div>
  )
}
export default Rich;